import { ACTION_ARGS, Arg, MODAL_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import { fn } from '@ember/helper';
import { isPresent } from '@ember/utils';
import { on } from '@ember/modifier';
import DestructiveButton from '../../action/button/destructive.gjs';
import PrimaryButton from '../../action/button/primary.gjs';
import SecondaryButton from '../../action/button/secondary.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Shared footer CTA with primary and optional secondary button.',
  extends: [
    pick(ACTION_ARGS, ['beforeClose', 'close']),
    pick(MODAL_ARGS, [
      { name: 'primaryBtnAction', required: true },
      'primaryBtnDisabled',
      { name: 'primaryBtnText', required: true },
      'secondaryBtnAction',
      'secondaryBtnDisabled',
      'secondaryBtnText',
    ]),
  ],
  meta: {
    danger: Arg.boolean({
      default: false,
      description: 'Use destructive style for primary button',
    }),
  },
  name: 'Footer Cta',
});

export default class SpdsModalSharedFooterCta extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  get primaryBtnComponent() {
    return this.args.danger ? DestructiveButton : PrimaryButton;
  }

  get primaryBtnType() {
    return this.args.danger ? 'destructive' : 'primary';
  }

  get showSecondaryButton() {
    return isPresent(this.args.secondaryBtnAction) && isPresent(this.args.secondaryBtnText);
  }

  <template>
    {{#if this.showSecondaryButton}}
      <SecondaryButton
        @disabled={{@secondaryBtnDisabled}}
        data-test-spds-modal-shared-footer-cta-secondary-button
        {{on "click" (fn @secondaryBtnAction @close)}}
      >
        {{@secondaryBtnText}}
      </SecondaryButton>
    {{/if}}
    <this.primaryBtnComponent
      @disabled={{@primaryBtnDisabled}}
      data-test-spds-modal-shared-footer-cta-primary-button={{this.primaryBtnType}}
      {{on "click" (fn @primaryBtnAction @close)}}
      {{this.validateArguments}}
    >
      {{@primaryBtnText}}
    </this.primaryBtnComponent>
  </template>
}

export const MODAL_SHARED_FOOTER_CTA_METADATA = SpdsModalSharedFooterCta.metadata;
